export default "__VITE_ASSET__ee4a9819__"